import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
//import { CardActionArea } from '@mui/material';

class ExtendCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = { counter: 0 };
    }
    componentDidMount = () =>{
        console.log("ExtendCard - componentDidMount()");
    }
    CardMediaCreate = ()=>{
        if(this.props.panelimage === ""){
            return null;
        }
        return (
            <CardMedia
                component="img"
                height={150}
                image={this.props.panelimage}
                alt="panelimage"
                />
        )
    }
    render() {
        return (
            <Card sx={{ width:'96%',maxWidth: 800 }}>
                <CardHeader
                        title={this.props.title}
                        subheader={this.props.datestring}/>
                        {this.CardMediaCreate()}
                    <CardContent>
                        {this.props.children}
                    </CardContent>
            </Card>
        );
    }

}

export default ExtendCard;